import { render, staticRenderFns } from "./LossesByProductTabContent.vue?vue&type=template&id=8e83c726&scoped=true"
import script from "./LossesByProductTabContent.vue?vue&type=script&lang=js"
export * from "./LossesByProductTabContent.vue?vue&type=script&lang=js"
import style0 from "./LossesByProductTabContent.vue?vue&type=style&index=0&id=8e83c726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e83c726",
  null
  
)

export default component.exports